import { render, staticRenderFns } from "./UnidadesMedida.vue?vue&type=template&id=5d9548f6&scoped=true"
import script from "./UnidadesMedida.vue?vue&type=script&lang=js"
export * from "./UnidadesMedida.vue?vue&type=script&lang=js"
import style0 from "./UnidadesMedida.vue?vue&type=style&index=0&id=5d9548f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9548f6",
  null
  
)

export default component.exports